export const UserRoleType = {
    DEFAULT: "",
    DEV: "dev",
    ADMIN: "admin",
    CUSTOMER: "customer",
    VALIDATOR: "validator",
    CLIENT_ADMIN: "client_admin",
    DEMO_ACCOUNT: "demo_account",
};
